export default function RechargeTips() {
  const methods = [
    {
      icon: 'ri-eye-line',
      title: '感受五感',
      desc: '暫時放下手機，專注望下身邊嘅樹、抬頭睇下天空、聽下雀仔聲，感受微風吹過皮膚與樹木的氣味，讓感知重回當下。',
    },
    {
      icon: 'ri-hand-heart-line',
      title: '觸摸樹木',
      desc: '伸出雙手觸摸樹幹與樹皮的紋理，透過實體接觸讓神經系統快速沉澱下來。',
    },
    {
      icon: 'ri-windy-line',
      title: '慢步深呼吸',
      desc: '放慢腳步，平靜深呼吸；情況允許的話，不妨赤腳踩踩草地進行 Grounding（接地氣），釋放積存的緊繃感。',
    },
    {
      icon: 'ri-mental-health-line',
      title: '樹下靜坐冥想',
      desc: '在樹下閉上雙眼微冥想，純粹聆聽大自然的聲音，給大腦一個極速重置的機會。',
    },
  ];

  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-semibold tracking-widest uppercase mb-5 whitespace-nowrap">
            <i className="ri-timer-flash-line"></i>
            Quick Recharge · 快速叉電
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 leading-[1.6]">
            忙碌的香港人，給自己 10 分鐘時間
          </h2>

          {/* Subtle line accent to frame the heading */}
          <div className="mt-5 flex items-center justify-center gap-2.5">
            <div className="w-8 h-px bg-foreground-300/50"></div>
            <div className="w-1.5 h-1.5 rounded-full bg-primary-400/70"></div>
            <div className="w-8 h-px bg-foreground-300/50"></div>
          </div>

          {/* Main intro text */}
          <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto">
            再忙碌的生活，也值得一個小 Break。走到附近的樹下，花幾分鐘，幫自己快速叉電：
          </p>

          {/* Research highlight - directly below intro line */}
          <div className="mt-5 max-w-lg mx-auto">
            <div className="rounded-2xl bg-accent-50 border border-accent-100/60 p-5">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed font-medium">
                <i className="ri-lightbulb-flash-line text-accent-500 mr-1.5"></i>
                研究顯示，只需短短 10 分鐘的自然接觸，就能帶來明顯的放鬆效果！
              </p>
            </div>
          </div>
        </div>

        {/* Park path image */}
        <div className="max-w-4xl mx-auto mb-10">
          <div className="rounded-2xl overflow-hidden aspect-video">
            <img
              src="https://public.readdy.ai/ai/img_res/edited_0fd4fd1aef349fcb4d48b880a5604a9a_b8628c2f.jpg"
              alt="陽光穿透樹蔭的公園步道，充滿生命力的綠意"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>

        {/* Methods grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          {methods.map((m, idx) => (
            <div
              key={idx}
              className="group rounded-2xl bg-white border border-black/5 shadow-soft p-5 transition-all duration-300 hover:shadow-soft"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${m.icon} text-lg`}></i>
                </div>
                <span className="text-xs font-bold text-accent-600 bg-accent-100/80 rounded-full px-2.5 py-1 whitespace-nowrap">
                  0{idx + 1}
                </span>
              </div>
              <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{m.title}</h4>
              <div className="w-9 h-[3px] rounded-full bg-accent-400/70 mb-3"></div>
              <p className="text-sm text-foreground-600 leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>

        {/* Hydration tip */}
        <div className="max-w-lg mx-auto">
          <div className="rounded-2xl bg-secondary-50 border border-secondary-100/60 p-5 flex gap-3 items-start">
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 shrink-0">
              <i className="ri-drop-line text-lg"></i>
            </div>
            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                🌿 小貼士
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                記得適時補充水分，讓身體與心靈同步維持流動與平衡。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}